import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import classnames from "classnames"
import {
  getContentComponentForStepType,
  getManageComponentForStepType
} from "library/show/components/content"
import BlocksContainer from "library/show/components/content/blocks/BlocksContainer"
import StepContentAttributionContainer from "./StepContentAttributionContainer"
import "./styles/StepContent.css"

const shouldRenderBlocks = (step, isEditing) => {
  const canEdit = isEditing === true && step.permissions.can_edit === true
  // Always render blocks in edit mode
  if (!step.content && canEdit) return true

  // render blocks if this is blocks content
  if (step.content && step.content.type === "blocks") return true

  return false
}

function StepContent({
  step,
  content,
  isEditing,
  onContentSaved,
  isLicensed,
  handleBlocksCompletion,
  handleLegacyContentCompletion
}) {
  let stepType = step.assignment_type

  let isLoading = step.content && step.content.id && !content

  let canEdit = step.permissions.can_edit_content

  let className = classnames("StepContent")

  if (step.content && content != null ? content.id : undefined) {
    className = classnames(
      className,
      `StepContent__${step.content.type}--${content.method}`
    )
  }

  if (shouldRenderBlocks(step, isEditing)) {
    const mode = isEditing && canEdit ? "edit" : "view"
    const key = `${step.id}-${mode}`

    const renderedBlocks = isLicensed ? (
      <StepContentAttributionContainer
        isLocalContent={step.id === step.sync_source_id}
        // isEditing={isEditing}
      >
        <BlocksContainer
          key={key}
          step={step}
          mode={mode}
          onSave={onContentSaved}
          handleBlocksCompletion={handleBlocksCompletion}
        />
      </StepContentAttributionContainer>
    ) : (
      <BlocksContainer
        key={key}
        step={step}
        mode={mode}
        onSave={onContentSaved}
        handleBlocksCompletion={handleBlocksCompletion}
      />
    )

    return (
      <div
        className={className}
        style={{
          minHeight: `${isLoading ? 300 : 0}px`,
          ...(mode === "edit"
            ? {
                backgroundColor: "rgba(150,150,150,0.2)",
                padding: "15px 10px"
              }
            : {})
        }}
      >
        {renderedBlocks}
      </div>
    )
  }

  let ManageContent = getManageComponentForStepType(stepType)
  if (ManageContent.default) ManageContent = ManageContent.default
  let ViewContent = getContentComponentForStepType(stepType)
  if (ViewContent.default) ViewContent = ViewContent.default

  // Here we need to check for Platform version to show new content
  return (
    <div
      className={className}
      style={{ minHeight: `${isLoading ? 300 : 0}px` }}
    >
      {isLoading ? (
        <LoadingCircle />
      ) : isEditing && canEdit ? (
        <ManageContent />
      ) : content ? (
        isLicensed ? (
          <StepContentAttributionContainer
            isLocalContent={step.id === step.sync_source_id}
            isEditing={isEditing}
          >
            <ViewContent
              content={content}
              step={step}
              handleLegacyContentCompletion={handleLegacyContentCompletion}
            />
          </StepContentAttributionContainer>
        ) : (
          <ViewContent
            content={content}
            step={step}
            handleLegacyContentCompletion={handleLegacyContentCompletion}
          />
        )
      ) : null}
    </div>
  )
}

export default StepContent
